import {
    PieChart as RechartsPieChart,
    Pie,
    Cell,
    ResponsiveContainer,
    Legend,
    Tooltip,
  } from 'recharts';
import AnalyticsEmptyState from "../../dashboard/AnalyticsEmptyState";
import { CHART_MARK_STROKE, CHART_MARK_STROKE_WIDTH } from '../../../helpers/chartPalette';
import usePieChartLayout from '../../../hooks/usePieChartLayout';

const ScaleDevelopmentPieChart = ({ groupedData, colors, totalResponses }) => {
  // Legenda onder de taart op een smal scherm (gedeelde rapportage op een telefoon).
  const { layout, onResize, ref } = usePieChartLayout(groupedData ? groupedData.length : 0);

   if (!groupedData || groupedData.length === 0) {
     return <AnalyticsEmptyState />;
   }

   // Transform groupedData into the pie chart format
   const pieData = groupedData.map((item) => ({
     name: item.moment, // Use 'moment' as the name
     value: parseFloat(item.average), // Convert 'average' to a number
   }));

 // Custom tooltip content
 const CustomTooltip = ({ active, payload }) => {
   if (active && payload && payload.length) {
     const { name, value } = payload[0].payload;
     return (
       <div
         style={{
           backgroundColor: 'white',
           padding: '10px',
           border: '1px solid #ccc',
           borderRadius: '5px',
         }}
       >
         <p style={{ margin: 0, fontWeight: 'bold' }}>{name}</p>
         <p style={{ margin: 0 }}>{`Gemiddelde score: ${value}`}</p>
       </div>
     );
   }
   return null;
 };

 return (
   <div
     ref={ref}
     /* Smal zet de grafiek zelf een hoogte in pixels; dan geen vaste wrapperhoogte. */
     className={`scale-development-chart${layout.narrow ? ' scale-development-chart--sized' : ''}`}
   >
     {/* Breed: de hoogte van de ouder, zoals altijd; smal: hoog genoeg voor de legenda eronder. */}
     <ResponsiveContainer width="100%" height={layout.narrow ? layout.height : '100%'} onResize={onResize}>
       <RechartsPieChart>
         <Pie
           data={pieData}
           cx={layout.cx}
           cy="50%"
           innerRadius={0}
           outerRadius={layout.outerRadius}
           paddingAngle={0}
           dataKey="value"
           labelLine={false}
          //  label={({ name, value }) => `${name} (${value})`}
         >
           {pieData.map((entry, index) => (
             <Cell
               key={`cell-${index}`}
               fill={colors[index % colors.length]} // Cycle through COLORS
               stroke={CHART_MARK_STROKE}
               strokeWidth={CHART_MARK_STROKE_WIDTH}
             />
           ))}
         </Pie>
         <Tooltip content={<CustomTooltip />} />
         <Legend
           layout={layout.legend.layout}
           align={layout.legend.align}
           verticalAlign={layout.legend.verticalAlign}
           wrapperStyle={{
             paddingLeft: '10px',
           }}
         />
       </RechartsPieChart>
     </ResponsiveContainer>
   </div>
 );
}

export default ScaleDevelopmentPieChart